<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex font-semibold justify-between items-center">
    <mat-card-title class=""><span class="text-3xl">
      Senha enviada
    </span>
    </mat-card-title>
  </mat-card-header>
  <div>
    <div class="flex justify-center text-center text-2xl font-medium gap-4 items-center mt-3">
      Uma senha foi gerada e enviada <br> para o email do{{data?.item?.nome ? '(a) ' + data?.item?.nome : ' usuário'}}
    </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      (click)="close()"
    >
      Fechar
    </button>
  </div>
</mat-card>
